import { create } from "zustand";

interface PopupStore {
  isOpen: boolean;
  openPopup: () => void;
  closePopup: () => void;
  togglePopup: () => void;
  isTourSkipped: boolean;
  setIsTourSkipped: (isTourSkipped: boolean) => void;
}

export const usePopupStore = create<PopupStore>((set) => ({
  isOpen: false,
  openPopup: () => set({ isOpen: true }),
  closePopup: () => set({ isOpen: false }),
  togglePopup: () => set((state) => ({ isOpen: !state.isOpen })),
  isTourSkipped: false,
  setIsTourSkipped: (state: boolean) => set({ isTourSkipped : state }),
}));
